import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Heart, Dog, Cloud, MapPin } from "lucide-react";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import Cookies from "js-cookie";

const AboutUs = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:900px)");
    const isTablet = useMediaQuery("(max-width:1200px)");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const id = Cookies.get("id");
    const getUserId = () => {
        const id = Cookies.get("id");
        return id;
    };

    const pageStyle = {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#fff",
    };
    const dogIcon = '/icons/aboutDog.png';
    const aboutCloudIcon = '/icons/aboutCloud.png';
    const aboutMapIcon = '/icons/aboutMap.png';

    const contentStyle = {
        flex: "1 0 auto",
        position: "relative",
        width: "100%",
        paddingTop: isMobile ? "60px" : "70px",
    };

    const HeroSection = () => (
        <div style={{
            backgroundColor: "white",
            position: "relative",
            width: "100%",
            overflow: "hidden",
            minHeight: isMobile ? "400px" : "500px",
            backgroundImage: "linear-gradient(135deg, rgba(101, 168, 251, 0.1) 0%, rgba(255, 182, 12, 0.1) 100%)"
        }}>
            <div style={{
                position: "relative",
                maxWidth: "1280px",
                margin: "auto",
                padding: isMobile ? "60px 20px" : isTablet ? "80px 40px" : "120px 80px"
            }}>
                <div style={{ maxWidth: isMobile ? "100%" : "800px" }}>
                    <h1 style={{
                        fontSize: isMobile ? "32px" : isTablet ? "44px" : "56px",
                        color: "#050505",
                        lineHeight: 1.2,
                        marginBottom: isMobile ? "16px" : "24px",
                        fontWeight: "bold"
                    }}>
                        <span style={{ color: "#65a8fb" }}>{t('aboutUs.hero.title')}</span>
                    </h1>
                    <p style={{
                        fontSize: isMobile ? "16px" : isTablet ? "20px" : "24px",
                        color: "#050505",
                        lineHeight: 1.6,
                        marginBottom: isMobile ? "24px" : "32px"
                    }}>
                        {t('aboutUs.hero.description')}
                    </p>
                    <div
                        onClick={() => { if (getUserId()) navigate('/pet-management'); else navigate('/login') }}
                        style={{
                            backgroundColor: "#ffb60c",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: isMobile ? "14px 24px" : "16px 32px",
                            borderRadius: "3px",
                            cursor: "pointer"
                        }}>
                        <span style={{
                            fontSize: isMobile ? "16px" : "18px",
                            color: "#050505",
                            fontWeight: "bold"
                        }}>{t('aboutUs.hero.cta')}</span>
                    </div>
                </div>
            </div>
            <div style={{
                position: "absolute",
                bottom: 0,
                right: 0,
                width: isMobile ? "200px" : isTablet ? "350px" : "500px",
                height: isMobile ? "200px" : isTablet ? "350px" : "500px",
                opacity: 0.2
            }}>
                <Heart style={{ width: "100%", height: "100%", color: "#65a8fb" }} strokeWidth={0.5} />
            </div>
        </div>
    );

    const BrandStory = () => (
        <div style={{ backgroundColor: "#fcf8f3", padding: isMobile ? "60px 0" : isTablet ? "80px 0" : "100px 0" }}>
            <div style={{
                maxWidth: "1280px",
                margin: "auto",
                padding: isMobile ? "0 20px" : isTablet ? "0 40px" : "0 80px",
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                gap: isMobile ? "40px" : isTablet ? "60px" : "80px",
                alignItems: "center"
            }}>
                <div>
                    <h2 style={{
                        fontSize: isMobile ? "32px" : isTablet ? "38px" : "44px",
                        color: "#050505",
                        marginBottom: isMobile ? "16px" : "24px",
                        fontWeight: "bold"
                    }}>
                        {t('aboutUs.story.title')}
                    </h2>
                    <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? "16px" : "24px" }}>
                        <div>
                            <h3 style={{
                                fontSize: isMobile ? "22px" : isTablet ? "26px" : "28px",
                                color: "#65a8fb",
                                marginBottom: isMobile ? "8px" : "12px",
                                fontWeight: "bold"
                            }}>
                                {t('aboutUs.story.mission.title')}
                            </h3>
                            <p style={{
                                fontSize: isMobile ? "16px" : isTablet ? "18px" : "21px",
                                color: "#050505",
                                lineHeight: 1.6
                            }}>
                                {t('aboutUs.story.mission.description')}
                            </p>
                        </div>
                        <div>
                            <h3 style={{
                                fontSize: isMobile ? "22px" : isTablet ? "26px" : "28px",
                                color: "#65a8fb",
                                marginBottom: isMobile ? "8px" : "12px",
                                fontWeight: "bold"
                            }}>
                                {t('aboutUs.story.vision.title')}
                            </h3>
                            <p style={{
                                fontSize: isMobile ? "16px" : isTablet ? "18px" : "21px",
                                color: "#050505",
                                lineHeight: 1.6
                            }}>
                                {t('aboutUs.story.vision.description')}
                            </p>
                        </div>
                    </div>
                </div>
                <div style={{
                    position: "relative",
                    height: isMobile ? "300px" : isTablet ? "400px" : "500px",
                    borderRadius: isMobile ? "20px" : "30px",
                    overflow: "hidden"
                }}>
                    <img
                        src="https://images.unsplash.com/photo-1705175975965-c25516b7fcd8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxoYXBweSUyMHBldCUyMG93bmVyJTIwZG9nfGVufDF8fHx8MTc2OTM1MDE4MHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
                        alt="Happy pet owner with dog"
                        style={{ position: "absolute", width: "100%", height: "100%", objectFit: "cover" }}
                    />
                </div>
            </div>
        </div>
    );

    const CoreTechnology = () => {
        const technologies = [
            { icon: dogIcon, title: t('aboutUs.technology.ai.title'), description: t('aboutUs.technology.ai.description'), color: "#65a8fb" },
            { icon: aboutCloudIcon, title: t('aboutUs.technology.cloud.title'), description: t('aboutUs.technology.cloud.description'), color: "#ffb60c" },
            { icon: aboutMapIcon, title: t('aboutUs.technology.database.title'), description: t('aboutUs.technology.database.description'), color: "#65a8fb" }
        ];

        return (
            <div style={{ backgroundColor: "white", padding: isMobile ? "60px 0" : isTablet ? "80px 0" : "100px 0" }}>
                <div style={{ maxWidth: "1280px", margin: "auto", padding: isMobile ? "0 20px" : isTablet ? "0 40px" : "0 80px" }}>
                    <div style={{ textAlign: "center", marginBottom: isMobile ? "40px" : isTablet ? "60px" : "80px" }}>
                        <h2 style={{
                            fontSize: isMobile ? "32px" : isTablet ? "38px" : "44px",
                            color: "#050505",
                            marginBottom: isMobile ? "12px" : "16px",
                            fontWeight: "bold"
                        }}>
                            {t('aboutUs.technology.title.part1')}<span style={{ color: "#65a8fb" }}>{t('aboutUs.technology.title.part2')}</span>
                        </h2>
                    </div>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : isTablet ? "1fr" : "repeat(3, 1fr)",
                        gap: isMobile ? "40px" : isTablet ? "50px" : "60px"
                    }}>
                        {technologies.map((tech, index) => (
                            <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                                <div style={{
                                    marginBottom: isMobile ? "16px" : "24px",
                                    padding: isMobile ? "16px" : "24px",
                                    borderRadius: "50%",
                                    backgroundColor: `${tech.color}20`
                                }}>
                                    {typeof tech.icon === 'string' ? (
                                        <img
                                            src={tech.icon}
                                            alt={tech.title}
                                            style={{
                                                width: isMobile ? "50px" : "60px",
                                                height: isMobile ? "50px" : "60px",
                                                objectFit: "contain"
                                            }}
                                        />
                                    ) : (
                                        <tech.icon style={{
                                            width: isMobile ? "50px" : "60px",
                                            height: isMobile ? "50px" : "60px",
                                            color: tech.color
                                        }} strokeWidth={1.5} />
                                    )}
                                </div>
                                <h3 style={{
                                    fontSize: isMobile ? "22px" : isTablet ? "26px" : "28px",
                                    marginBottom: isMobile ? "12px" : "16px",
                                    fontWeight: "bold",
                                    color: tech.color
                                }}>
                                    {tech.title}
                                </h3>
                                <p style={{
                                    fontSize: isMobile ? "15px" : isTablet ? "16px" : "18px",
                                    color: "#050505",
                                    lineHeight: 1.6
                                }}>
                                    {tech.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    const ProductAdvantages = () => (
        <div style={{ backgroundColor: "#fcf8f3", padding: isMobile ? "60px 0" : isTablet ? "80px 0" : "100px 0" }}>
            <div style={{ maxWidth: "1280px", margin: "auto", padding: isMobile ? "0 20px" : isTablet ? "0 40px" : "0 80px" }}>
                <div style={{ textAlign: "center", marginBottom: isMobile ? "40px" : isTablet ? "60px" : "80px" }}>
                    <h2 style={{
                        fontSize: isMobile ? "32px" : isTablet ? "38px" : "44px",
                        color: "#050505",
                        marginBottom: "16px",
                        fontWeight: "bold"
                    }}>
                        {t('aboutUs.advantages.title.part1')} <span style={{ color: "#65a8fb" }}>{t('aboutUs.advantages.title.part2')}?</span>
                    </h2>
                </div>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
                    gap: isMobile ? "24px" : isTablet ? "32px" : "40px"
                }}>
                    <div style={{
                        backgroundColor: "white",
                        padding: isMobile ? "24px" : isTablet ? "28px" : "32px",
                        borderRadius: isMobile ? "16px" : "20px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: isMobile ? "16px" : "24px"
                    }}>
                        <div style={{
                            width: isMobile ? "56px" : "72px",
                            height: isMobile ? "56px" : "72px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(101, 168, 251, 0.1)",
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <div>
                                <svg width={isMobile ? "50px" : "72px"} height={isMobile ? "50px" : "72px"} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z" fill="#65A8FB" />
                                    <path d="M47.6667 34.3359H24.3333C22.4924 34.3359 21 35.8283 21 37.6693V49.3359C21 51.1769 22.4924 52.6693 24.3333 52.6693H47.6667C49.5076 52.6693 51 51.1769 51 49.3359V37.6693C51 35.8283 49.5076 34.3359 47.6667 34.3359Z" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M27.6641 34.3359V27.6693C27.6641 25.4591 28.542 23.3395 30.1048 21.7767C31.6676 20.2139 33.7873 19.3359 35.9974 19.3359C38.2075 19.3359 40.3271 20.2139 41.89 21.7767C43.4528 23.3395 44.3307 25.4591 44.3307 27.6693V34.3359" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <div>
                            <h3 style={{
                                fontSize: isMobile ? "20px" : isTablet ? "22px" : "24px",
                                color: "#050505",
                                marginBottom: isMobile ? "8px" : "12px",
                                fontWeight: "bold"
                            }}>{t('aboutUs.advantages.privacy.title')}</h3>
                            <p style={{
                                fontSize: isMobile ? "15px" : isTablet ? "16px" : "18px",
                                color: "#050505",
                                lineHeight: 1.6
                            }}>{t('aboutUs.advantages.privacy.description')}</p>
                        </div>
                    </div>
                    <div style={{
                        backgroundColor: "white",
                        padding: isMobile ? "24px" : isTablet ? "28px" : "32px",
                        borderRadius: isMobile ? "16px" : "20px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: isMobile ? "16px" : "24px"
                    }}>
                        <div style={{
                            width: isMobile ? "56px" : "72px",
                            height: isMobile ? "56px" : "72px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(101, 168, 251, 0.1)",
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <div>
                                <svg width={isMobile ? "50px" : "72px"} height={isMobile ? "50px" : "72px"} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z" fill="#65A8FB" />
                                    <path d="M46 29.3359C46 26.6838 44.9464 24.1402 43.0711 22.2649C41.1957 20.3895 38.6522 19.3359 36 19.3359C33.3478 19.3359 30.8043 20.3895 28.9289 22.2649C27.0536 24.1402 26 26.6838 26 29.3359C26 41.0026 21 44.3359 21 44.3359H51C51 44.3359 46 41.0026 46 29.3359Z" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M38.8839 51C38.5908 51.5051 38.1703 51.9244 37.6642 52.2159C37.1582 52.5073 36.5845 52.6608 36.0005 52.6608C35.4166 52.6608 34.8428 52.5073 34.3368 52.2159C33.8308 51.9244 33.4102 51.5051 33.1172 51" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <div>
                            <h3 style={{
                                fontSize: isMobile ? "20px" : isTablet ? "22px" : "24px",
                                color: "#050505",
                                marginBottom: isMobile ? "8px" : "12px",
                                fontWeight: "bold"
                            }}>{t('aboutUs.advantages.tracking.title')}</h3>
                            <p style={{
                                fontSize: isMobile ? "15px" : isTablet ? "16px" : "18px",
                                color: "#050505",
                                lineHeight: 1.6
                            }}>{t('aboutUs.advantages.tracking.description')}</p>
                        </div>
                    </div>
                    <div style={{
                        backgroundColor: "white",
                        padding: isMobile ? "24px" : isTablet ? "28px" : "32px",
                        borderRadius: isMobile ? "16px" : "20px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: isMobile ? "16px" : "24px"
                    }}>
                        <div style={{
                            width: isMobile ? "56px" : "72px",
                            height: isMobile ? "56px" : "72px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(101, 168, 251, 0.1)",
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <div>
                                <svg width={isMobile ? "50px" : "72px"} height={isMobile ? "50px" : "72px"} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z" fill="#65A8FB" />
                                    <path d="M49.7359 36.4009C51.6123 34.5245 52.6665 31.9795 52.6665 29.3259C52.6665 26.6722 51.6123 24.1273 49.7359 22.2509C47.8595 20.3745 45.3146 19.3203 42.6609 19.3203C40.0073 19.3203 37.4623 20.3745 35.5859 22.2509L24.3359 33.5009V47.6675H38.5026L49.7359 36.4009Z" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M42.6693 29.3359L19.3359 52.6693" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M45.1667 41H31" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <div>
                            <h3 style={{
                                fontSize: isMobile ? "20px" : isTablet ? "22px" : "24px",
                                color: "#050505",
                                marginBottom: isMobile ? "8px" : "12px",
                                fontWeight: "bold"
                            }}>{t('aboutUs.advantages.design.title')}</h3>
                            <p style={{
                                fontSize: isMobile ? "15px" : isTablet ? "16px" : "18px",
                                color: "#050505",
                                lineHeight: 1.6
                            }}>{t('aboutUs.advantages.design.description')}</p>
                        </div>
                    </div>
                    <div style={{
                        backgroundColor: "white",
                        padding: isMobile ? "24px" : isTablet ? "28px" : "32px",
                        borderRadius: isMobile ? "16px" : "20px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: isMobile ? "16px" : "24px"
                    }}>
                        <div style={{
                            width: isMobile ? "56px" : "72px",
                            height: isMobile ? "56px" : "72px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(101, 168, 251, 0.1)",
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <div>
                                <svg width={isMobile ? "50px" : "72px"} height={isMobile ? "50px" : "72px"} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z" fill="#65A8FB" />
                                    <path d="M44.3307 51V47.6667C44.3307 45.8986 43.6283 44.2029 42.3781 42.9526C41.1279 41.7024 39.4322 41 37.6641 41H24.3307C22.5626 41 20.8669 41.7024 19.6167 42.9526C18.3664 44.2029 17.6641 45.8986 17.6641 47.6667V51" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M31.0026 34.3333C34.6845 34.3333 37.6693 31.3486 37.6693 27.6667C37.6693 23.9848 34.6845 21 31.0026 21C27.3207 21 24.3359 23.9848 24.3359 27.6667C24.3359 31.3486 27.3207 34.3333 31.0026 34.3333Z" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M54.3359 51.0021V47.6687C54.3348 46.1916 53.8432 44.7567 52.9382 43.5893C52.0332 42.4218 50.7662 41.588 49.3359 41.2188" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M42.6641 21.2188C44.0981 21.5859 45.3691 22.4199 46.2768 23.5893C47.1845 24.7586 47.6771 26.1968 47.6771 27.6771C47.6771 29.1574 47.1845 30.5956 46.2768 31.7649C45.3691 32.9342 44.0981 33.7682 42.6641 34.1354" stroke="white" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <div>
                            <h3 style={{
                                fontSize: isMobile ? "20px" : isTablet ? "22px" : "24px",
                                color: "#050505",
                                marginBottom: isMobile ? "8px" : "12px",
                                fontWeight: "bold"
                            }}>{t('aboutUs.advantages.social.title')}</h3>
                            <p style={{
                                fontSize: isMobile ? "15px" : isTablet ? "16px" : "18px",
                                color: "#050505",
                                lineHeight: 1.6
                            }}>{t('aboutUs.advantages.social.description')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const CTASection = () => (
        <div style={{ backgroundColor: "#fff2d3", padding: isMobile ? "60px 0" : isTablet ? "80px 0" : "100px 0" }}>
            <div style={{
                maxWidth: "1280px",
                margin: "auto",
                padding: isMobile ? "0 20px" : isTablet ? "0 40px" : "0 80px",
                textAlign: "center"
            }}>
                <h2 style={{
                    fontSize: isMobile ? "32px" : isTablet ? "38px" : "44px",
                    color: "#050505",
                    marginBottom: isMobile ? "16px" : "24px",
                    fontWeight: "bold"
                }}>
                    {t('aboutUs.cta.title')}
                </h2>
                <p style={{
                    fontSize: isMobile ? "18px" : isTablet ? "20px" : "24px",
                    color: "#050505",
                    marginBottom: isMobile ? "24px" : "32px"
                }}>
                    {t('aboutUs.cta.subtitle')}
                </p>
                <div style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: isMobile ? "16px" : "20px",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div
                        onClick={() => navigate('/login')}
                        style={{
                            backgroundColor: "#ffb60c",
                            width: isMobile ? "100%" : "auto",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: isMobile ? "16px 28px" : "18px 32px",
                            borderRadius: "3px",
                            cursor: "pointer"
                        }}>
                        <span style={{
                            fontSize: isMobile ? "16px" : "18px",
                            color: "#050505",
                            fontWeight: "bold"
                        }}>{t('aboutUs.cta.button1')}</span>
                    </div>
                    <div
                        onClick={() => navigate('/ptag-air')}
                        style={{
                            border: "1px solid #050505",
                            width: isMobile ? "100%" : "auto",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: isMobile ? "16px 28px" : "18px 32px",
                            borderRadius: "3px",
                            cursor: "pointer"
                        }}>
                        <span style={{
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: "bold"
                        }}>{t('aboutUs.cta.button2')}</span>
                    </div>
                </div>
                <p style={{
                    fontSize: isMobile ? "14px" : "16px",
                    color: "#86868B",
                    marginTop: isMobile ? "24px" : "32px"
                }}>
                    {t('aboutUs.cta.footer')}
                </p>
            </div>
        </div>
    );

    return (
        <div style={pageStyle}>
            <Navbar />
            <div style={contentStyle}>
                <HeroSection />
                <BrandStory />
                <CoreTechnology />
                <ProductAdvantages />
                <CTASection />
            </div>
            <Footer />
        </div>
    );
};

export default AboutUs;
